import { BaseFragmentModel } from '../BaseFragment/BaseFragmentModel';
import { ParsedFragmentEntity, RawParsedFragment } from './Types';
import { QuestionEntity } from '../Question/Types';
import { ItemTypeEntity } from '../ItemType/Types';
import { QuestionModel } from '../Question/QuestionModel';
import { ItemTypeModel } from '@entities/ItemType/ItemTypes';
import { ProjectAddItemFragmentPayload } from '../../Processes/Gateways/CustomProjects/Interfaces/ProjectAddItemPayload';
import {
    ProjectFragmentOrderedQtyPayload,
    ProjectItemTypeOrderedQtyPayload,
} from '../../Processes/Gateways/CustomProjects/Interfaces/ProjectItemOrderedQtyPayload';

export class ParsedFragmentModel
    extends BaseFragmentModel
    implements ParsedFragmentEntity
{
    index: number = 0;
    progress?: number;
    isStyle?: boolean;
    fragmentStyleId?: number | null = null;
    questions?: QuestionEntity[] = [];
    itemTypes: ItemTypeEntity[] = [];

    constructor(data?: RawParsedFragment) {
        super(data);
        if (data) {
            this.initialize(data);
        }
    }

    initialize(data: RawParsedFragment) {
        super.initialize(data);
        this.index = data.index;
        this.progress = data.progress;
        this.isStyle = data.is_style;
        this.fragmentStyleId = data.fragment_style_id;
        this.questions = data.questions?.length
            ? data.questions.map(question => new QuestionModel(question))
            : [];
        this.itemTypes = data.item_types.map(item => new ItemTypeModel(item));
    }

    parse(): RawParsedFragment {
        return {
            ...super.parse(),
            index: this.index,
            progress: this.progress,
            is_style: this.isStyle,
            fragment_style_id: this.fragmentStyleId,
            questions: this.questions?.map(question => question.parse()),
            item_types: this.itemTypes.map(item => item.parse()), // Переопределяем item_types
        };
    }

    getAddItemPayload(): ProjectAddItemFragmentPayload[] {
        return this.itemTypes
            .filter(itemType => itemType.items && itemType.items.length > 0)
            .map(itemType => ({
                ...itemType.getAddItemPayload(),
                fragment_id: this.id,
                fragment_index: this.index,
            }));
    }

    getOrderedQtyPayload(): ProjectFragmentOrderedQtyPayload[] {
        const itemTypesPayload: ProjectItemTypeOrderedQtyPayload[] =
            this.itemTypes.flatMap(itemType => itemType.getOrderedQtyPayload());

        return itemTypesPayload.map(payload => ({
            ...payload,
            fragment_id: this.id,
            fragment_index: this.index,
        }));
    }
}
